import SalesForceOpportunityBillingHeaderIndex from "@/components/sales_force/opportunity_billing/header/SalesForceOpportunityBillingIndex.vue";
import SalesForceOpportunityBillingDetail from "@/components/sales_force/opportunity_billing/header/SalesForceOpportunityBillingDetail.vue";

let routesSalesForceOpportunityBillingAccess= [
    {
        path: 'header',
        meta: {
          title: "Sales Force Opportunity Billing",
        },
        name: "SalesForceOpportunityBillingHeaderIndex",
        component: SalesForceOpportunityBillingHeaderIndex
    },
    {
        path: 'header/detail/:id',
        meta: {
            title: "Sales Force Opportunity Billing Detail",
        },
        name: "SalesForceOpportunityBillingDetail",
        component: SalesForceOpportunityBillingDetail
    },
    
]

export default routesSalesForceOpportunityBillingAccess
  